import { FormMode } from '../../enums';
import React from 'react';

import { FormContextProps } from './form-context-props.interface';

export const FormContext = React.createContext<FormContextProps>(
  Object.assign({ formMode: FormMode.Update })
);
